import { createContext } from 'react';
import type { ShareSettingsPublicProviderContextValue } from '../../types';

export const ShareSettingsContext = createContext<ShareSettingsPublicProviderContextValue | null>(null);
